import moment from 'moment';

class OData {
    constructor() {
        this.between = (column, minValue, maxValue, type = 'string') => {
            if (minValue || maxValue) {
                this.query += ' and ';
            }
            if (minValue) {
                this.query += `${column} ge ${this.type(minValue, type)}`;
            }
            if (minValue && maxValue) {
                this.query += ' and ';
            }
            if (maxValue) {
                this.query += `${column} le ${this.type(maxValue, type)}`;
            }
        };
        this.equal = (column, value, type = 'string') => {
            if (value) {
                this.query += ` and ${column} eq ${this.type(value, type)}`;
            }
        };
        this.substringof = (column, value) => {
            if (value) {
                this.query += ` and substringof('${value}', ${column})`;
            }
        };
        this.type = (field, type) => {
            switch (type) {
                case 'integer':
                    return field;
                case 'date':
                    return `datetime'${moment(field).format('YYYY-MM-DD')}'`;
                default:
                    // string
                    return `'${field}'`;
            }
        };
        this.getQuery = () => this.query;
        this.query = '&$filter=1 eq 1';
    }
}

export { OData };
